module.exports = __webpack_public_path__ + "static/Google-838ce8ba50438b425b94462d3cf8afaa.png";